import { Outlet, useParams } from 'react-router-dom';
import './SolicitudesWorkspace.css';

// Desktop shows one view at a time: the inbox table, or the open request as a
// page of its own with a link back to the table.
export default function SolicitudesWorkspace() {
  const { quoteId } = useParams();
  return (
    <div className="sol-workspace">
      <section
        className="sol-workspace__content"
        aria-label={quoteId ? 'Detalle de solicitud' : undefined}
      >
        <Outlet key={quoteId || 'inbox'} />
      </section>
    </div>
  );
}
